import axios, { AxiosHeaders, CanceledError } from "axios";
import PaginatedResponse from "common/contracts/paginated-response";
import AttorneyHubAPIService from "common/services/api/attorney-hub-api-service";
import Session from "users/session/session";
import UserCoworkerQuery from "users/values/user-coworker/api/request-contracts/query-user-coworker-api-request";
import UserCoworkerAPIResponse from "users/values/user-coworker/api/response-contracts/user-coworker-api-response";
import UserCoworker, { IUserCoworker } from "users/values/user-coworker/user-coworker";

export default class UserCoworkerApiService {
    private readonly authHeaders: AxiosHeaders = new AxiosHeaders();

  constructor(session: Readonly<Session>) {
    if (!session.authToken?.value)
      throw new Error("Session must have an authToken to create a UserCoworkerAPIService");
    this.authHeaders.set("Authorization", `Bearer ${session.authToken.value}`);
  }

  async getUserCoworkers(
    query: UserCoworkerQuery,
    abortController?: AbortController
  ): Promise<PaginatedResponse<UserCoworker>> {
    const url = new URL(
      `/users/coworkers?${query.asSearchParams().toString()}`,
      AttorneyHubAPIService.apiBaseUrl
    );
    try {
      const response = await axios.get(url.toString(), {
        headers: this.authHeaders,
        signal: abortController?.signal
      });

      const responseData = response.data.map(
        (coworkerData: IUserCoworker) => Object.assign(
            new UserCoworkerAPIResponse(),
            coworkerData
        ).deserialize()
      );

      return PaginatedResponse.from<UserCoworker>(
        responseData,
        response.headers['x-pagination']
      );
    }
    catch (error) {
      if (error instanceof CanceledError)
        throw error;
      throw new UserCoworkerAPIServiceError("getUserCoworkers", error);
    }
  }
}

export class UserCoworkerAPIServiceError extends Error {
  constructor(
    public readonly method: string,
    public readonly error: unknown
  ) {
    super(`UserCoworkerAPIServiceError: ${method} - ${error}`);
  }
}
